import React from "react";

import TransactionsModal from "../../../components/transactions-modal/TransactionsModal";
import SvgLoadingAnimation from "../../../components/loading";
import {
  useGetAccountMeQuery,
  useGetAccountTransactionsQuery,
  type AccountUser,
} from "../../../app/services/accounts";

interface AccountTransactionsModalProps {
  /** 一覧で「進行中」を押した対象ユーザー */
  user: AccountUser;
  onClose: () => void;
}

/**
 * アカウント管理ページの「進行中」モーダル。
 *
 * 対象ユーザー本人として（`X-Act-As-User` 付き）進行中取引と残高を取得し、
 * 既存のグローバル `TransactionsModal` にそのまま注入する。
 * `currentUserId` に対象ユーザー ID を渡すことで、委託/受託の判定も
 * 本人視点と同じになる。
 */
const AccountTransactionsModal: React.FC<AccountTransactionsModalProps> = ({
  user,
  onClose,
}) => {
  const { data: meResponse } = useGetAccountMeQuery(user.id);
  const { data: txData, isLoading } = useGetAccountTransactionsQuery(user.id);

  // 取得完了までは空リストを誤表示しない
  if (isLoading || !txData) {
    return <SvgLoadingAnimation />;
  }

  return (
    <TransactionsModal
      transactions={txData.data?.transactions ?? []}
      currentUserId={user.id}
      balanceSource={meResponse?.data ?? null}
      onClose={onClose}
    />
  );
};

export default AccountTransactionsModal;
